import { useEffect, useState } from 'react';
import { showLocaleSwitcher } from '@/i18n/locale';

export function useShowLocaleSwitcher() {
  const [showLocale, setShowLocale] = useState(false);

  useEffect(() => {
    async function load() {
      const show = await showLocaleSwitcher();
      setShowLocale(show === 'true');
    }

    load();
  }, []);

  return showLocale;
}
